var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B37AEFAC-653C-4FB6-8325-FBB7D1AB0AC7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 1424,
    height: 724,
    rx: 10
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.9%",
    y: "-2.1%",
    width: "103.8%",
    height: "107.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 12,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.04 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Consultant",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Timesheet-Copy-4",
    transform: "translate(-1402.000000, -425.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F8F8FA",
    x: 0,
    y: 0,
    width: 1680,
    height: 2039
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(156.000000, 152.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "outine",
    stroke: "#E0E0E0",
    x: 37,
    y: 90,
    width: 1350,
    height: 260,
    rx: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Project-Pending",
    transform: "translate(173.000000, 256.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.1,
    fill: "#BF6B00",
    x: 0,
    y: 0,
    width: 1174,
    height: 52
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1073.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "!",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E86B07",
    cx: 9,
    cy: 9,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.088,11.64 L7.816,3.72 L10.04,3.72 L9.768,11.64 L8.088,11.64 Z M8.92,15.16 C8.568,15.16 8.264,15.032 8.008,14.776 C7.752,14.52 7.624,14.216 7.624,13.864 C7.624,13.5013333 7.752,13.192 8.008,12.936 C8.264,12.68 8.568,12.552 8.92,12.552 C9.28266667,12.552 9.592,12.68 9.848,12.936 C10.104,13.192 10.232,13.5013333 10.232,13.864 C10.232,14.216 10.104,14.52 9.848,14.776 C9.592,15.032 9.28266667,15.16 8.92,15.16 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadAlert);
export default __webpack_public_path__ + "static/media/upload-alert.de4a85fedf477a548279a3f6f40c74d9.svg";
export { ForwardRef as ReactComponent };